/**
 * Cookie da sessão do SOAC (transversal/at-97, `BUG-V93`). Espelho de
 * `oficina-app-backend/src/auth/cookies-de-sessao.ts` — os nomes e a data de corte precisam ser
 * os mesmos nos dois lados.
 *
 * O nome era `token`, o mesmo do SAAC: em `localhost` o cookie é por host, não por porta, e os
 * dois sistemas abertos no mesmo navegador sobrescreviam a sessão um do outro.
 */
export const COOKIE_TOKEN = 'soac_token';

/** Até esta data o nome antigo ainda é lido, para quem estava logado no deploy. */
const COOKIE_TOKEN_ANTIGO = 'token';
const FIM_DO_NOME_ANTIGO = new Date('2026-12-01T00:00:00-03:00');

function lerCookie(nome: string): string | undefined {
  // Comparação pelo nome EXATO: um `split('token=')` também casaria `soac_token=`.
  for (const parte of document.cookie.split(';')) {
    const [chave, ...resto] = parte.trim().split('=');
    if (chave === nome) return resto.join('=') || undefined;
  }
  return undefined;
}

export function lerTokenDoCookie(agora: Date = new Date()): string | undefined {
  const novo = lerCookie(COOKIE_TOKEN);
  if (novo) return novo;
  return agora.getTime() < FIM_DO_NOME_ANTIGO.getTime() ? lerCookie(COOKIE_TOKEN_ANTIGO) : undefined;
}

/** Apaga o cookie legível da sessão, com o nome novo e o antigo. O refresh é httpOnly: só o logout do backend o apaga. */
export function limparCookieDaSessao(): void {
  const dominio = process.env.REACT_APP_COOKIE_DOMAIN ? `domain=${process.env.REACT_APP_COOKIE_DOMAIN};` : '';
  for (const nome of [COOKIE_TOKEN, COOKIE_TOKEN_ANTIGO]) {
    document.cookie = `${nome}=; Max-Age=0; path=/; ${dominio} same_site=None;`;
  }
}
